<template>
	<div class="input-group mb-3">
		<input 
			:id="id"
			:type="type" 
			:class="classChild" 
			:name="name" 
			ref="inputPass" 
			@change="changeHandler()"
			aria-describedby="password-addon" 
            :placeholder="(type == 'password' ? '●●●●●●●●●●' : 'Contraseña')" 
            required 
            style="padding-right: 40px;"
            autocomplete="on">
		<div class="input-group-right">
	        <button class="btn btn-transparent text-muted d-flex align-items-center h-100" type="button" @click="togglePassword" style="border: 0px !important; box-shadow: none !important;">
	            <span v-show="type=='text'">
	            	<i class="fas fa-eye"></i>
	            </span>
	            <span v-show="type=='password'">
	            	<i class="fas fa-eye-slash"></i>
	            </span>
	        </button>
	    </div>
	</div>
</template>
<script type="text/javascript">
	export default {
		props: ['value', 'classChild', 'name', 'id'],

		data(){
			return {
				type: 'password',
				icon: 'fas fa-eye'
			}
		},

		methods: {
			togglePassword(){
				if (this.type =='password') {
					this.type = 'text'
				}else{
					this.type = 'password'
				}
			},

			changeHandler(){
				var vm = this
				vm.$emit('input', this.value)
			}
		},

		watch: {
            value: function (value) {
            	this.$nextTick(() => {
			    	this.$refs.inputPass.value = value
			    });
            },

            type: function(value){
            	if (value == 'text') {
            		this.icon = 'fa fa-eye'
            	}else{
            		this.icon = 'fa fa-eye-slash'
            	}
            }
        },
	}
</script>